<style lang="scss" scoped>
@import "@/scss/main.scss";

#alb-logo {
    height: auto;
    max-width: 42%;
    max-height: 64px;
}

#sponsor-logo {
    width: 100%;
    height: auto;
    max-width: 432px;
}

#blm-logo {
    width: auto;
    height: 60px;
}

#bum-logo {
    width: auto;
    height: 65px;
}

.small {
    font-size: 0.8rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

.costum-button {
    background: $green;
    &:hover {
       background: $green-lighten;
    }
}

.fade-page-enter-active,
.fade-page-leave-active {
    transition: all 0.8s ease;
    opacity: 1.0;
}

.fade-page-enter-from,
.fade-page-leave-to {
    opacity: 0.0;
}

.border-primary {
  border-color: $green !important;
}

</style>


<template>
    <div class="antialiased border-top-wide border-primary d-flex flex-column">
        <div class="page page-center">
            <transition name="fade-page" appear>
            <div class="container-tight py-4 ">
                <div class="text-center mb-1 mb-3">
                    <a href="https://www.alb-bayern.de/" target="_blank"><img id="alb-logo" src="@/assets/logo.png" alt="ALB Bayern e.V."></a>
                </div>
                <form v-on:submit.prevent="logIn" class="card card-md"  autocomplete="off">
                    <div class="card-body">
                        <h2 class="text-center mt-1 mb-2 display-6">
                            Bewässerungs-App
                        </h2>
                        <div class="text-center text-muted mb-3">
                            Mobile Dokumentation von Wasserentnahmen, Grundwasserstandsmessungen, Bewässerungsmaßnahmen und lokalen Niederschlägen
                        </div>
                        
                        <transition name="fade">
                            <div v-if="!isLoginValid" class="alert alert-danger" role="alert">
                              <h4 class="alert-title">Zugangsdaten nicht korrekt</h4>
                              <div class="text-muted">Sie konnten nicht angemeldet werden. Bitte überprüfen Sie ihren Benutzernamen und ihr Passwort.</div>
                            </div>
                        </transition>
                        
                        <transition name="fade">
                            <div v-if="!isConsentValid" class="alert alert-danger" role="alert">
                              <h4 class="alert-title">Nutzungsbedingungen</h4>
                              <div class="text-muted">Bitte akzeptieren Sie die Nutzungsbedingungen und die Datenschutzerklärung.</div>
                            </div>
                        </transition>
                        
                        <transition name="fade">
                            <div v-if="isRequestError" class="alert alert-danger" role="alert">
                              <h4 class="alert-title">Serverfehler</h4>
                              <div class="text-muted">Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.</div>
                            </div>
                        </transition>
                    
                        <transition name="fade">
                        <div v-show="showFull">
                            <div class="mb-2">
                                <label class="form-label">
                                    Benutzername
                                </label>
                                <input v-model="username" ref="username" @focus="resetCheck" :class="{ 'form-control': true, 'is-invalid': !isLoginValid }" placeholder="Benutzername">
                            </div>
                            <div class="mb-2">
                                <label class="form-label">
                                    Passwort
                                    <span v-if="false" class="form-label-description">
                                        <a href="./forgot-password.html">Vergessen?</a>
                                    </span>
                                </label>
                                <div class="input-group input-group-flat">
                                    <input v-model="password" @focus="resetCheck" v-bind:type="passwordFieldType" :class="{ 'form-control': true, 'is-invalid': !isLoginValid }" placeholder="Passwort" autocomplete="off">
                                    <span v-if="isLoginValid" class="input-group-text">
                                        <a href="#" @click.prevent="switchVisibility" class="link-secondary" title="Zeige Passwort" >
                                            <svg v-if="isPasswordVisible" xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                               <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                               <circle cx="12" cy="12" r="2"></circle>
                                               <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"></path>
                                            </svg>
                                            <svg v-if="!isPasswordVisible" xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                               <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                               <line x1="3" y1="3" x2="21" y2="21"></line>
                                               <path d="M10.584 10.587a2 2 0 0 0 2.828 2.83"></path>
                                               <path d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"></path>
                                            </svg>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="form-check"> 
                                    <input v-model="consent" type="checkbox" :class="{ 'form-check-input': true, 'is-invalid': !isConsentValid }" />
                                    <span class="form-check-label">
                                        Ich akzeptiere die 
                                            <a href="https://www.alb-bayern.de/M/Haftungsausschluss.html" target="_blank">Nutzungsbedingungen</a> 
                                        und die 
                                            <a href="https://www.alb-bayern.de/M/Datenschutzerklaerung.html" target="_blank">Datenschutzerklärung</a> 
                                    </span>
                                </label>
                            </div>
                            <div class="mb-2">
                                <label class="form-check">
                                    <input v-model="stayLoggedIn" type="checkbox" class="form-check-input" />
                                    <span class="form-check-label">
                                        Angemeldet bleiben
                                    </span>
                                </label>
                            </div>
                        </div>
                        </transition>
                        
                        <div class="form-footer mt-2">
                            <div v-visible="isLoading" class="progress progress-sm mb-2">
                              <div class="progress-bar progress-bar-indeterminate bg-green"></div>
                            </div>
                            <button type="submit" class="btn btn-info w-100 costum-button" @click="doLogin" >
                                {{ showFull ? 'Anmelden': 'Hier anmelden' }} 
                            </button>
                        </div>
                    </div>
                    <div class="hr-text">
                        oder
                    </div>
                                       
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <a href="https://www.alb-bayern.de/M/Bewaesserung/Steuerungsmodelle/dokumentantion-speicherung-nutzerprofil_RegistrierungBewaesserungsApp.html" target="_blank" class="btn btn-white w-100">                                
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-login" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                       <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                       <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"></path>
                                       <path d="M20 12h-13l3 -3m0 6l-3 -3"></path>
                                    </svg>                    
                                    Zugang anfordern
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
                <div v-if="false" class="text-center mt-4 mb-4">
                    <div class="row">
                        <div class="col">
                            <a href="https://www.stmelf.bayern.de/" target="_blank"><img id="blm-logo" src="@/assets/blm.png" alt="Bayerisches Staatsministerium für Ernährung, Landwirtschaft und Forsten"></a>
                        </div>
                        <div class="col">
                            <a href="https://www.stmuv.bayern.de/" target="_blank"><img id="bum-logo" src="@/assets/bum.png" alt="Bayerisches Staatsministerium für Umwelt und Verbraucherschutz"></a>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col text-azure small">
                            Bayerisches Staatsministerium für Ernährung, Landwirtschaft und Forsten
                        </div>
                        <div class="col text-azure small">
                            Bayerisches Staatsministerium für Umwelt und Verbraucherschutz
                        </div>
                    </div>
                </div>
                <div class="text-center mt-4 mb-4">
                    <div class="row">
                        <div class="col">
                            <a href="https://www.stmelf.bayern.de/" target="_blank"><img id="sponsor-logo" src="@/assets/logo-sponsor.png" alt="Bayerisches Staatsministerium für Ernährung, Landwirtschaft und Forsten / Bayerisches Staatsministerium für Umwelt und Verbraucherschutz"></a>
                        </div>
                    </div>
                </div>
            </div>
            </transition>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

export
default {
    name: 'About',
    components: {
        
    },
    inject: [
        'state',
        'config'
    ],
    data: function () {
        return {
            username : '',
            password : '',
            passwordFieldType: 'password',
            consent: false,
            checkConsentActive : false,
            stayLoggedIn: false,
            checkLogInActive : false,
            loading: false,
            isRequestError: false,
            showFull: false
        }
    },
    computed: {
        isPasswordVisible: function () {
            return ! (this.passwordFieldType === 'password');
        },
        isLoginValid: function () {
            return !(this.checkLogInActive === true && false === false );
        },
        isConsentValid: function () {
            return !(this.checkConsentActive === true && this.consent === false );
        },
        isLoading: function () {
            return this.loading;
        }
    },
    methods: {
        checkConsent: function () {
            this.checkConsentActive = true;
            return !(this.consent === false);
        },
        doLogin: function (event) {
            if ( this.showFull == false ) {
                let self = this;
            
                event.preventDefault();
                event.target.blur();
                
                this.showFull = true;
                
                self.$nextTick( function() { 
                    //self.$refs.username.focus();
                });
            }
        },
        logIn: function () {
            let self = this;
            
            if ( ! self.checkConsent() ) {
                return false;
            }
                        
            let query = {
                query: `
                     mutation ($username: String!, $password: String!) { 
                        logIn(username: $username, password: $password) {
                            success
                            token
                        }
                    }
                `,      
                variables: {
                    username: self.username,
                    password: self.password
                }           
            }
            
            let request = Object.assign({}, self.config.request);
            request["data"] = query;
            
            self.loading = true;
            
            axios(request).then( function (response) {
            
                if ( response.data.data.logIn.success === true ) {
                    
                    let token = response.data.data.logIn.token;
                    let expireTimes = self.stayLoggedIn === true ? -1: 0;
                    self.state.actions.logIn(token, expireTimes);
                    
                    self.$nextTick(function () {
                        self.username = '';
                        self.password = '';
                    })
                    
                } else {
                    self.checkLogInActive = true;
                }
            
            }).catch(function (error) {
                console.log(error);
                self.isRequestError = true;
            }).then(function () {
                self.loading = false;
            });

        },
        switchVisibility: function() {
            if ( this.passwordFieldType === 'password' ) {
                this.passwordFieldType = 'text';
            } else {
                this.passwordFieldType = 'password';
            }
        },
        resetCheck : function () {
            this.checkConsentActive = false;
            this.checkLogInActive = false;
        }  
    }
}

</script>
